import { upsertArray } from "helpers/service_helper"
import {
  GET_GASPROJECTS_FAIL,
  GET_GASPROJECTS_SUCCESS,
  RESET_GASPROJECT_FLAG,
  UPSERT_GASPROJECT_FAIL,
  UPSERT_GASPROJECT_SUCCESS,
  ADD_FILE_GASPROJECT_FAIL,
  ADD_FILE_GASPROJECT_SUCCESS,
  GET_GASPROJECTS_ENG_SUCCESS,
  GET_GASPROJECTS_ENG_FAIL,
  GET_GASPROJECTS_ENG,
  GET_GASPROJECTS,
  UPDATE_PROCESS_STAGE_FAIL,
  UPDATE_PROCESS_STAGE_SUCCESS,
  UPDATE_PROCESS_EXPERT_STAGE,
  GET_GASPROJECT_FILES,
  GET_GASPROJECT_FILES_SUCCESS,
  GET_GASPROJECT_FILES_FAIL,
  GET_PACKAGEINSTALLER,
  GET_PACKAGEINSTALLER_SUCCESS,
  GET_PACKAGEINSTALLER_FAIL,
  SEND_GASPROJECT_TOGAS_FAIL,
  SEND_GASPROJECT_TOGAS_SUCCESS,
  SEND_GASPROJECT_TOGAS,
  SUBMIT_GASPROJECT_ADMIN_FAIL,
  SUBMIT_GASPROJECT_ADMIN,
  SUBMIT_GASPROJECT_ADMIN_SUCCESS,
  ADD_PACKAGE_INSTALLER_FAIL,
  ADD_PACKAGE_INSTALLER,
  ADD_PACKAGE_INSTALLER_SUCCESS,
  SUBMIT_PACKAGE,
  SUBMIT_PACKAGE_FAIL,
  SUBMIT_PACKAGE_SUCCESS,
  UPDATE_GASPROJECT_DETAILS,
  UPDATE_GASPROJECT_DETAILS_SUCCESS,
  DELETE_GASPROJECT_FAIL,
  DELETE_GASPROJECT_SUCCESS,
  UPDATE_GASPROJECT,
  UPDATE_GASPROJECT_SUCCESS,
  UPDATE_GASPROJECT_FAIL,
  UPDATE_GASPROJECT_ENG,
  GET_GASPROJECT_REPORT,
  GET_GASPROJECT_REPORT_SUCCESS,
  GET_GASPROJECT_REPORT_FAIL,
  GET_GASPROJECT_FREE,
  GET_GASPROJECT_FREE_FAIL,
  GET_GASPROJECT_FREE_SUCCESS,
  GET_GASPROJECTS_FILTER,
  GET_GASPROJECTS_FILTER_SUCCESS,
  GET_GASPROJECTS_FILTER_FAIL,
  GET_GASPROJECTS_FULL_FILTER,
  GET_GASPROJECTS_FULL_FILTER_SUCCESS,
  GET_GASPROJECTS_FULL_FILTER_FAIL,
  UPDATE_PROCESS_EXPERT_STAGE_NEW,
  UPDATE_PROCESS_DEFECT_STAGE_NEW,
  UPDATE_PROCESS_MAP_STAGE_NEW,
  UPDATE_PROCESS_STAGE_NEW_FAIL,
  UPDATE_PROCESS_STAGE_NEW_SUCCESS,
  UPDATE_GASPROJECT_DETAILS_NEW,
  UPDATE_GASPROJECT_DETAILS_NEW_SUCCESS,
  UPDATE_GASPROJECT_DETAILS_FAIL,
  UPDATE_GASPROJECT_DETAILS_NEW_FAIL,
  UPDATE_GASPROJECT_ENG_NEW,
  RESET_PACKAGE,
  RESET_PACKAGE_SUCCESS,
  RESET_PACKAGE_FAIL,
  RESOLVED_DEFECT,
  RESOLVED_DEFECT_SUCCESS,
  RESOLVED_DEFECT_FAIL,
  STOP_GASPROJECT,
  STOP_GASPROJECT_SUCCESS,
  STOP_GASPROJECT_FAIL,
  ADD_FILE_GASPROJECT_SINGLE,
  PREPARE_MAPSTAGE,
  PREPARE_MAPSTAGE_FAIL,
  PREPARE_MAPSTAGE_SUCCESS,
  SUBMIT_DESIGN_STAGE,
  SUBMIT_DESIGN_STAGE_SUCCESS,
  SUBMIT_DESIGN_STAGE_FAIL,
  PREPARE_FIRSTSUPERVISION_STAGE,
  PREPARE_FIRSTSUPERVISION_STAGE_SUCCESS,
  PREPARE_FIRSTSUPERVISION_STAGE_FAIL,
  UPDATE_GASPROJECT_CHECKLIST,
  UPDATE_GASPROJECT_CHECKLIST_SUCCESS,
  UPDATE_GASPROJECT_CHECKLIST_FAIL,
  SUBMIT_FIRSTSUPERVISION_STAGE,
  SUBMIT_FIRSTSUPERVISION_STAGE_SUCCESS,
  SUBMIT_FIRSTSUPERVISION_STAGE_FAIL,
  ADD_FILE_GASPROJECT,
  DELETE_GASPROJECT_FILE,
  DELETE_GASPROJECT_FILE_SUCCESS,
  PREPARE_DESIGNS_STAGE_FAIL,
  PREPARE_DESIGNS_STAGE,
  PREPARE_DESIGNS_STAGE_SUCCESS,
  PAY_BY_EXECUTOR_WALLET,
  PAY_BY_EXECUTOR_WALLET_SUCCESS,
  PAY_BY_EXECUTOR_WALLET_FAIL,
  GET_GASPROJECT_INFO_PUBLIC,
  GET_GASPROJECT_INFO_PUBLIC_SUCCESS,
  GET_GASPROJECT_INFO_PUBLIC_FAIL,
  GET_GASPROJECTS_FULL_FILTER_EXCEL,
  GET_GASPROJECTS_FULL_FILTER_EXCEL_SUCCESS,
  GET_GASPROJECTS_FULL_FILTER_EXCEL_FAIL,
} from "./actionTypes"
import { DELETE_USER_FILE_FAIL } from "store/users/actionTypes"
import { FileGasProjectType } from "models/types/file-gas-project-type"

const INIT_STATE = {
  lstGasProjects: [],
  lstGasProjectsFilter: [],
  lstGasProjectsFullFilter: [],
  lstGasProjectReport: [],
  lstGasProjectsTotal: 0,
  lstGasProjectsFullFilterTotal: 0,
  lstGasProjectReportTotal: 0,
  lstGasProjectFiles: [],
  gasProjectFree: null,
  lstPackageInstaller: [],
  //costPermitDomestic: 1651000,
  // costPermitDomestic: 2500000,
  costPermitDomestic: 3062500,
  //costPermitDomesticPlus: 301600,
  // costPermitDomesticPlus: 456600,
  costPermitDomesticPlus: 570000,
  // costPermitIndustrial: 3575000,
  // costPermitIndustrial: 5413000,
  costPermitIndustrial: 6766000,
  minUserBalance: 0,
  currentIdGasProject: [],
  addedPlanFile: false,
  error: "",
  success: "",
  loading: false,
  actionName: {},
  triggerReload: 0,
  gasProjectInfoPublic: null,
}

const gasProjects = (state = INIT_STATE, action) => {
  switch (action.type) {
    //#region loading
    case GET_GASPROJECTS:
    case GET_GASPROJECTS_FILTER:
    case GET_GASPROJECTS_FULL_FILTER:
    case GET_GASPROJECT_REPORT:
    case GET_GASPROJECTS_ENG:
    case UPDATE_PROCESS_EXPERT_STAGE:
    case UPDATE_PROCESS_EXPERT_STAGE_NEW:
    case UPDATE_PROCESS_DEFECT_STAGE_NEW:
    case UPDATE_PROCESS_MAP_STAGE_NEW:
    case GET_GASPROJECT_FILES:
    case GET_GASPROJECT_FREE:
    case GET_PACKAGEINSTALLER:
    case SEND_GASPROJECT_TOGAS:
    case SUBMIT_GASPROJECT_ADMIN:
    case ADD_PACKAGE_INSTALLER:
    case SUBMIT_PACKAGE:
    case UPDATE_GASPROJECT_DETAILS:
    case UPDATE_GASPROJECT_DETAILS_NEW:
    case UPDATE_GASPROJECT:
    case UPDATE_GASPROJECT_ENG:
    case UPDATE_GASPROJECT_ENG_NEW:
    case RESET_PACKAGE:
    case RESOLVED_DEFECT:
    case PREPARE_MAPSTAGE:
    case PREPARE_FIRSTSUPERVISION_STAGE:
    case PREPARE_DESIGNS_STAGE:
    case STOP_GASPROJECT:
    case ADD_FILE_GASPROJECT_SINGLE:
    case SUBMIT_DESIGN_STAGE:
    case SUBMIT_FIRSTSUPERVISION_STAGE:
    case UPDATE_GASPROJECT_CHECKLIST:
    case ADD_FILE_GASPROJECT:
    case GET_GASPROJECT_INFO_PUBLIC:
    case DELETE_GASPROJECT_FILE:
    case PAY_BY_EXECUTOR_WALLET:
    case GET_GASPROJECTS_FULL_FILTER_EXCEL:
      return {
        ...state,
        loading: true,
      }
    //#endregion

    //#region Success
    case DELETE_GASPROJECT_FILE_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        success: "فایل با موفقیت حذف شد",
        lstGasProjectFiles: state.lstGasProjectFiles.filter(
          files => files.id !== action.payload.id
        ),
      }
    case GET_GASPROJECTS_ENG_SUCCESS:
      return {
        ...state,
        loading: false,
        success: "پرونده آپدیت شد",
        triggerReload: state.triggerReload + 1,
      }
    case GET_GASPROJECTS_SUCCESS:
      return {
        ...state,
        loading: false,
        lstGasProjects: action.payload.data,
        lstGasProjectsTotal: action.payload.totalItems,
        success: "لیست پرونده آپدیت شد",
      }
    case GET_GASPROJECTS_FILTER_SUCCESS:
      return {
        ...state,
        loading: false,
        lstGasProjectsFilter: action.payload.data,
        lstGasProjectsFilterTotal: action.payload.totalItems,
        success: "لیست پرونده آپدیت شد",
      }
    case GET_GASPROJECTS_FULL_FILTER_SUCCESS:
      return {
        ...state,
        loading: false,
        lstGasProjectsFullFilter: action.payload.data,
        lstGasProjectsFullFilterTotal: action.payload.totalItems,
      }
    case GET_GASPROJECT_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        lstGasProjectReport: action.payload.data,
        lstGasProjectReportTotal: action.payload.totalItems,
        success: "لیست گزارش آپدیت شد",
      }
    case UPSERT_GASPROJECT_SUCCESS:
      return {
        ...state,
        loading: false,
        // lstGasProjects: upsertArray(state.lstGasProjects, action.payload),
        success: "پرونده با موفقیت ایجاد شد",
        currentIdGasProject: action.payload,
        error: null,
        addedPlanFile: false,
      }

    case DELETE_GASPROJECT_SUCCESS:
      return {
        ...state,
        loading: false,
        success: "پرونده با موفقیت حذف شد ",
        lstGasProjectsFullFilter: state.lstGasProjectsFullFilter.filter(
          f => f.id !== action.payload
        ),
        lstGasProjectsFullFilterTotal: state.lstGasProjectsFullFilterTotal - 1,
      }

    case GET_GASPROJECT_FILES_SUCCESS:
      return {
        ...state,
        loading: false,
        lstGasProjectFiles: action.payload,
        error: null,
      }
    case GET_GASPROJECT_FREE_SUCCESS:
      return {
        ...state,
        loading: false,
        gasProjectFree: action.payload,
        success: "پرونده بارگذاری شد",
        error: null,
      }
    case GET_PACKAGEINSTALLER_SUCCESS:
      return {
        ...state,
        loading: false,
        lstPackageInstaller: action.payload,
        success: "نصاب پرونده بارگذاری شدند",
        error: null,
      }

    case ADD_FILE_GASPROJECT_SUCCESS:
      return {
        ...state,
        loading: false,
        // lstGasProjects: upsertArray(state.lstGasProjects, action.payload),
        lstGasProjectsFullFilter: state.lstGasProjectsFullFilter?.map(x => {
          if (x.id === action.payload.id)
            console.log(
              "action.payload.fileTypeEnum,",
              action.payload.fileTypeEnum
            )

          return {
            ...x,
            isUploadFirstPlan:
              action.payload.fileTypeEnum === FileGasProjectType[2] ||
              x.isUploadFirstPlan,
            isUploadIdCard:
              action.payload.fileTypeEnum === FileGasProjectType[1] ||
              x.isUploadIdCard,
            isUploadApprovedPostalCode:
              action.payload.fileTypeEnum === FileGasProjectType[14] ||
              x.isUploadApprovedPostalCode,
            isUploadIsoPlan:
              action.payload.fileTypeEnum === FileGasProjectType[4] ||
              x.isUploadIsoPlan,
          }
          return x
        }),
        success: "فایل با موفقیت بارگذاری شد",
        error: null,
        addedPlanFile: true,
      }

    case UPDATE_PROCESS_STAGE_SUCCESS:
    case UPDATE_PROCESS_STAGE_NEW_SUCCESS:
    case SUBMIT_DESIGN_STAGE_SUCCESS:
    case SUBMIT_FIRSTSUPERVISION_STAGE_SUCCESS:
    case RESET_PACKAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: "تغییرات با موفقیت انجام شد",
        triggerReload: state.triggerReload + 1,
      }

    case RESOLVED_DEFECT_SUCCESS:
      return {
        ...state,

        lstGasProjectsFullFilter: state.lstGasProjectsFullFilter.map(x => {
          if (x.id === action.payload.id)
            return {
              ...x,
              isSolvedDefect: action.payload.resolved,
              solarSolvedDefect: action.payload.solarSolvedDefect,
            }
          return x
        }),
        loading: false,
        success: "این پرونده برای تخصیص آماده شد",
      }

    case PREPARE_MAPSTAGE_SUCCESS:
      return {
        ...state,

        lstGasProjectsFullFilter: state.lstGasProjectsFullFilter.map(x => {
          if (x.id === action.payload.id)
            return {
              ...x,
              isPrepareForMapStage: action.payload.prepare,
              solarPrepareForMapStage: action.payload.solarPrepareForMapStage,
              projectBalance: action.payload.amountDiscrepancy,
            }
          return x
        }),
        loading: false,
        success: action.payload.amountDiscrepancy
          ? "هزینه نقشه مجدد محاسبه شد"
          : "این پرونده برای تخصیص آماده شد",
      }

    case PREPARE_FIRSTSUPERVISION_STAGE_SUCCESS:
      return {
        ...state,
        lstGasProjectsFullFilter: state.lstGasProjectsFullFilter.map(x => {
          if (x.id === action.payload.id)
            return {
              ...x,
              isPrepareForFirstSupervisionStage: action.payload.prepare,
            }
          return x
        }),
        loading: false,
        success: "این پرونده برای نظارت اولیه آماده شد",
      }

    case PREPARE_DESIGNS_STAGE_SUCCESS:
      console.log("state.lstGasProjects", state.lstGasProjects)

      return {
        ...state,
        lstGasProjectsFullFilter: state.lstGasProjectsFullFilter.map(x => {
          if (x.id === action.payload.id)
            return {
              ...x,
              isPrepareForDesignStage: action.payload.prepare,
              solarPrepareForDesignStage:
                action.payload.solarPrepareForDesignStage,
            }
          return x
        }),
        loading: false,
        success: "این پرونده برای طراحی آماده شد",
      }

    case STOP_GASPROJECT_SUCCESS:
      return {
        ...state,
        lstGasProjectsFullFilter: state.lstGasProjectsFullFilter.map(x => {
          if (x.id === action.payload.id)
            return {
              ...x,
              isStop: action.payload.isStop,
              stopDes: action.payload.stopDes,
            }
          return x
        }),
        loading: false,
        success: "این پرونده متوقف شد",
      }
    case SEND_GASPROJECT_TOGAS_SUCCESS:
      return {
        ...state,
        loading: false,
        lstGasProjectsFullFilter: state.lstGasProjectsFullFilter.filter(
          f => f.id !== action.payload
        ),
        lstGasProjectsFullFilterTotal: state.lstGasProjectsFullFilterTotal - 1,
        success: "پرونده با موفقیت تسویه و در صف ارسال به شرکت گاز قرار گرفت",
      }

    case SUBMIT_GASPROJECT_ADMIN_SUCCESS:
      return {
        ...state,
        lstGasProjects: state.lstGasProjects.map(x => {
          if (
            x.id === action.payload.gasProjectId &&
            !action.payload.forPrepare
          )
            return { ...x, isOk: true }
          return x
        }),
        lstGasProjectsFullFilter: state.lstGasProjectsFullFilter.map(x => {
          if (x.id === action.payload) return { ...x, isOk: true }
          return x
        }),
        loading: false,
        success: action.payload.forPrepare
          ? "فایل ایزومتریک-پلان-تایید ایجاد شد"
          : "این پرونده تایید شد",
      }

    case ADD_PACKAGE_INSTALLER_SUCCESS:
      return {
        ...state,
        loading: false,
        success: "درخواست تایید برای نصاب ارسال شد",
      }

    case SUBMIT_PACKAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: "درخواست تایید شما با موفقیت انجام شد",
        triggerReload: state.triggerReload + 1,
      }
    case UPDATE_GASPROJECT_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: "الزامات با موفقیت به روز رسانی شد",
      }
    case UPDATE_GASPROJECT_DETAILS_NEW_SUCCESS:
      return {
        ...state,
        loading: false,
        success: "الزامات با موفقیت به روز رسانی شد",
        triggerReload: state.triggerReload + 1,
      }
    case UPDATE_GASPROJECT_SUCCESS:
      return {
        ...state,
        loading: false,
        success: "پرونده با موفقیت به روز رسانی شد",
        triggerReload: state.triggerReload + 1,
      }

    case UPDATE_GASPROJECT_CHECKLIST_SUCCESS:
      return {
        ...state,
        loading: false,
        triggerReload: state.triggerReload + 1,
        success: "چک لیست با موفقیت به روز رسانی شد",
      }

    case PAY_BY_EXECUTOR_WALLET_SUCCESS:
      return {
        ...state,
        lstGasProjects: state.lstGasProjects.map(x => {
          if (x.id === action.payload.id)
            return { ...x, projectBalance: action.payload.projectBalance }
          return x
        }),
        lstGasProjectsFullFilter: state.lstGasProjectsFullFilter.map(x => {
          if (x.id === action.payload.id)
            return { ...x, projectBalance: action.payload.projectBalance }
          return x
        }),
        loading: false,
        success: "پرداخت با موفقیت انجام شد",
      }

    case GET_GASPROJECTS_FULL_FILTER_EXCEL_SUCCESS:
      return {
        ...state,
        loading: false,
        success: "با موفقیت خروجی گرفته شد",
      }
    
    case GET_GASPROJECT_INFO_PUBLIC_SUCCESS:
       return {
        ...state,
        loading: false,
        gasProjectInfoPublic: action.payload,
        success: "با موفقیت اطلاعات پرونده بارگزاری شد",
      }

    //#endregion

    //#region Fails
    case GET_GASPROJECTS_FAIL:
    case GET_GASPROJECTS_FILTER_FAIL:
    case GET_GASPROJECTS_FULL_FILTER_FAIL:
    case GET_GASPROJECT_REPORT_FAIL:
    case GET_GASPROJECTS_ENG_FAIL:
    case UPSERT_GASPROJECT_FAIL:
    case ADD_FILE_GASPROJECT_FAIL:
    case UPDATE_PROCESS_STAGE_FAIL:
    case UPDATE_PROCESS_STAGE_NEW_FAIL:
    case GET_GASPROJECT_FILES_FAIL:
    case GET_GASPROJECT_FREE_FAIL:
    case GET_PACKAGEINSTALLER_FAIL:
    case SEND_GASPROJECT_TOGAS_FAIL:
    case SUBMIT_GASPROJECT_ADMIN_FAIL:
    case ADD_PACKAGE_INSTALLER_FAIL:
    case SUBMIT_PACKAGE_FAIL:
    case DELETE_GASPROJECT_FAIL:
    case UPDATE_GASPROJECT_FAIL:
    case UPDATE_GASPROJECT_DETAILS_FAIL:
    case UPDATE_GASPROJECT_DETAILS_NEW_FAIL:
    case RESET_PACKAGE_FAIL:
    case RESOLVED_DEFECT_FAIL:
    case PREPARE_MAPSTAGE_FAIL:
    case PREPARE_FIRSTSUPERVISION_STAGE_FAIL:
    case PREPARE_DESIGNS_STAGE_FAIL:
    case STOP_GASPROJECT_FAIL:
    case SUBMIT_DESIGN_STAGE_FAIL:
    case SUBMIT_FIRSTSUPERVISION_STAGE_FAIL:
    case UPDATE_GASPROJECT_CHECKLIST_FAIL:
    case DELETE_USER_FILE_FAIL:
    case PAY_BY_EXECUTOR_WALLET_FAIL:
    case GET_GASPROJECT_INFO_PUBLIC_FAIL:
    case GET_GASPROJECTS_FULL_FILTER_EXCEL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload ? action.payload : "خطای پیش بینی نشده",
        success: "",
      }
    //#endregion

    //#region Reset
    case RESET_GASPROJECT_FLAG:
      return {
        ...state,
        success: null,
        error: null,
      }
    //#endregion
    default:
      return state
  }
}

export default gasProjects
